module.exports = __webpack_public_path__ + "img/5.1a67b4d9.png";